import { Action, createReducer, on } from '@ngrx/store';
import { usersInitialState, UsersState } from './users.state';
import { UsersActions } from './users.actions';

const _usersReducer = createReducer(
  usersInitialState(),

  /**
   * Reducers For All Users
   */

  on(UsersActions.getAllUsers, (state) => {
    return {
      ...state,
      allUsers: {
        loading: true,
      },
    };
  }),
  on(UsersActions.getAllUsersSuccess, (state, { users }) => {
    return {
      ...state,
      allUsers: {
        loading: false,
        data: users.data,
      },
    };
  }),
  on(UsersActions.getAllUsersFailure, (state, { failure }) => {
    return {
      ...state,
      allUsers: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Send link
   */

  on(UsersActions.sendLink, (state) => {
    return {
      ...state,
      sendLink: {
        loading: true,
      },
    };
  }),
  on(UsersActions.sendLinkSuccess, (state, { response }) => {
    return {
      ...state,
      sendLink: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(UsersActions.sendLinkFailure, (state, { failure }) => {
    return {
      ...state,
      sendLink: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Reducers For Upload File
   */
  on(UsersActions.uploadFile, (state) => {
    return {
      ...state,
      uploadFile: {
        loading: true,
      },
    };
  }),
  on(UsersActions.uploadFileSuccess, (state, { response }) => {
    return {
      ...state,
      uploadFile: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(UsersActions.uploadFileFailure, (state, { failure }) => {
    return {
      ...state,
      uploadFile: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Upload File
   */
  on(UsersActions.getUsersCount, (state) => {
    return {
      ...state,
      usersCount: {
        loading: true,
      },
    };
  }),
  on(UsersActions.getUsersCountSuccess, (state, { response }) => {
    return {
      ...state,
      usersCount: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(UsersActions.getUsersCountFailure, (state, { failure }) => {
    return {
      ...state,
      usersCount: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Upload File
   */
  on(UsersActions.getUserDetails, (state) => {
    return {
      ...state,
      userDetails: {
        loading: true,
      },
    };
  }),
  on(UsersActions.getUserDetailsSuccess, (state, { user: users }) => {
    return {
      ...state,
      userDetails: {
        loading: false,
        data: users.data,
      },
    };
  }),
  on(UsersActions.getUserDetailsFailure, (state, { failure }) => {
    return {
      ...state,
      userDetails: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Upload File
   */
  on(UsersActions.updateUser, (state) => {
    return {
      ...state,
      updateUser: {
        loading: true,
      },
    };
  }),
  on(UsersActions.updateUserSuccess, (state, { response }) => {
    return {
      ...state,
      updateUser: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(UsersActions.updateUserFailure, (state, { failure }) => {
    return {
      ...state,
      updateUser: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Upload File
   */
  on(UsersActions.deleteUser, (state) => {
    return {
      ...state,
      deleteUser: {
        loading: true,
      },
    };
  }),
  on(UsersActions.deleteUserSuccess, (state, { response }) => {
    return {
      ...state,
      deleteUser: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(UsersActions.deleteUserFailure, (state, { failure }) => {
    return {
      ...state,
      deleteUser: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Forgot Password
   */
  on(UsersActions.forgotPassword, (state, { emailOrUsername }) => {
    return {
      ...state,
      resetPasswordEmail: emailOrUsername,
      forgotPassword: {
        loading: true,
      },
    };
  }),
  on(UsersActions.forgotPasswordSuccess, (state, { response }) => {
    return {
      ...state,
      resetPasswordCode: response.data,
      forgotPassword: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(UsersActions.forgotPasswordFailure, (state, { failure }) => {
    return {
      ...state,
      forgotPassword: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Reset Password
   */
  on(UsersActions.resetPassword, (state, {}) => {
    return {
      ...state,
      resetPassword: {
        loading: true,
      },
    };
  }),
  on(UsersActions.resetPasswordSuccess, (state, { response }) => {
    return {
      ...state,
      resetPassword: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(UsersActions.resetPasswordFailure, (state, { failure }) => {
    return {
      ...state,
      resetPassword: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For User Company Manager
   */
  on(UsersActions.updateCompanyManager, (state, {}) => {
    return {
      ...state,
      updateCompanyManager: {
        loading: true,
      },
    };
  }),
  on(UsersActions.updateCompanyManagerSuccess, (state, { response }) => {
    return {
      ...state,
      updateCompanyManager: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(UsersActions.updateCompanyManagerFailure, (state, { failure }) => {
    return {
      ...state,
      updateCompanyManager: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Confirm Account
   */
  on(UsersActions.confirmAccount, (state, {}) => {
    return {
      ...state,
      confirmAccount: {
        loading: true,
      },
    };
  }),
  on(UsersActions.confirmAccountSuccess, (state, { response }) => {
    return {
      ...state,
      confirmAccount: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(UsersActions.confirmAccountFailure, (state, { failure }) => {
    return {
      ...state,
      confirmAccount: {
        loading: false,
        failure: failure,
      },
    };
  }),

  /**
   * Action For Switch Admin | regular user
   */
  on(UsersActions.switchToAdmin, (state, { status }) => {
    return {
      ...state,
      isAdmin: status,
    };
  }),
  /**
   * Reducers For Create Company Manager
   */
  on(UsersActions.createCompanyManager, (state, {}) => {
    return {
      ...state,
      createCompanyManager: {
        loading: true,
      },
    };
  }),
  on(UsersActions.createCompanyManagerSuccess, (state, { response }) => {
    return {
      ...state,
      createCompanyManager: {
        loading: false,
        data: true,
      },
    };
  }),
  on(UsersActions.createCompanyManagerFailure, (state, { failure }) => {
    return {
      ...state,
      createCompanyManager: {
        loading: false,
        failure: failure,
      },
    };
  }),
  /**
   * Reducers For Resend Email
   */
  on(UsersActions.resendEmail, (state, {}) => {
    return {
      ...state,
      resendEmail: {
        loading: true,
      },
    };
  }),
  on(UsersActions.resendEmailSuccess, (state, { response }) => {
    return {
      ...state,
      resendEmail: {
        loading: false,
        data: response.data,
      },
    };
  }),
  on(UsersActions.resendEmailFailure, (state, { failure }) => {
    return {
      ...state,
      resendEmail: {
        loading: false,
        failure: failure,
      },
    };
  })
);

export function usersReducer(state: UsersState | undefined, action: Action) {
  return _usersReducer(state, action);
}
